import React from "react";
import styled from "styled-components";
import propBg from "../../../assets/images/Proósitos.jpg";
import services from "../../../constants/nosotros/services";
import ServicesList from "../../molecules/ServicesList";
const Service = () => {
	return (
		<Wrapper>
			<div className='container'>
				<div className='row'>
					<div className='col-md-12 col-lg-9 offset-lg-3'>
						<h1 className='mb-md-5'>Propósito</h1>
						<div className='row small-margin'>
							<ServicesList services={services} />
						</div>
					</div>
				</div>
			</div>
		</Wrapper>
	);
};

export default Service;

const Wrapper = styled.section`
	min-height: 700px;
	color: #fff;
	background: #00dcc0;

	@media (min-width: 992px) {
		background: #3cdbc0;
		background-image: url(${propBg});
		background-repeat: no-repeat;
	}

	h1 {
		font-weight: 700;
		font-size: 55px;
		margin-bottom: 30px;
		margin-top: 50px;
	}

	h5 {
		font-size: 22px;
		font-weight: 600;
	}

	p {
		font-size: 18px;
	}

	.media {
		margin-bottom: 20px;
		img {
			width: 30px;
			margin-right: 80px;
		}
	}

	.small-margin {
		margin-bottom: 300px;
		@media (min-width: 992px) {
			margin-bottom: 50px;
		}
	}

	@media (max-width: 767px) {
		padding: 40px 0;
		h1 {
			margin-top: 0;
			font-size: 30px;
			text-align: center;
		}
	}
`;
